// API Configuration - Configurazione centralizzata
// Runtime value (window._env_, generated by server.js) wins; build-time env is fallback.
const API_BASE_URL =
    (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_API_BASE_URL) ||
    process.env.REACT_APP_API_BASE_URL ||
    'http://localhost:8000/api';

const REACT_BASE_URL =
      (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_BASE_URL) ||
      process.env.REACT_APP_BASE_URL ||
      'http://localhost:3000';

const API_ENDPOINTS = {
    QUERY: '/query',
    QUERY_STREAM: '/query/stream',
    SESSIONS: '/sessions',
    UPLOAD_MESSAGES: '/upload_messages',
    EVENTI_PDF: '/eventi/pdf',
    SCORE: '/score',
    REGIONALI_XLSX: '/regionali/excel',
    VCO: '/vco'
};

const API_CLIENT_ID = 'soti-smart-caring-client'

export {API_BASE_URL, API_ENDPOINTS, API_CLIENT_ID, REACT_BASE_URL}